const createEventDetails = ({
  locationElement,
  startDate,
  endDate
}) => {
  const obj = {
    startDayOfWeek: startDate.dayOfWeek,
    startMonth: startDate.month,
    startDay: startDate.day,
    startTime: startDate.time
  };
  if (locationElement && locationElement.textContent) {
    obj.location = [{ title: locationElement.textContent }];
  }
  if (endDate) {
    obj.endDayOfWeek = endDate.dayOfWeek;
    obj.endMonth = endDate.month;
    obj.endDay = endDate.day;
    obj.endTime = endDate.time;
  }
  return obj;
};
export {
  createEventDetails
};
//# sourceMappingURL=createEventDetails.js.map
